<template>
  <div>
    <v-btn small icon @click.stop="handleShowFormClick">
      <v-icon small>fa-trash</v-icon>
    </v-btn>

    <v-dialog v-model="showModal" max-width="800">
      <v-card v-if="showModal">
        <v-card-title class="headline">Delete service?</v-card-title>
        <v-card-text>
          <v-text-field
            label="Comment"
            v-model="comment"/>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn @click="handleHideForm" :loading="requestInProgress">Cancel</v-btn>
          <v-btn @click="handleFormSubmit">Send</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import {mapActions} from 'vuex';
  import {notificationService} from '../../../application'

  export default {
    name: 'delete-case-service-form',
    components: {},
    props: {
      caseId: {
        type: String,
        required: true
      },
      serviceId: {
        type: String,
        required: true
      },
    },
    data() {
      return {
        showModal: false,
        comment: '',
        requestInProgress: false,
      }
    },
    methods: {
      ...mapActions({
        deleteCaseService: 'deleteCaseService'
      }),
      handleShowFormClick() {
        this.showModal = true
      },
      handleHideForm() {
        this.showModal = false
      },
      handleFormSubmit() {
        this.requestInProgress = true;
        this
          .deleteCaseService({
            caseId: this.caseId,
            serviceId: this.serviceId,
            comment: this.comment
          })
          .then(() => {
            this.requestInProgress = false;
            this.showModal = false;
            notificationService.info('Operation success');
            this.resetForm()
          })
          .catch(e => {
            this.requestInProgress = false;
            notificationService.error('Operation failed');
            throw e
          })
      },
      resetForm() {
        this.comment = ''
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Sales/case/DeleteCaseServiceForm.vue